import $ from 'jquery';
import _ from 'underscore';

var flag = 94;
var footer = $('.fat-footer');

$(window).scroll(
  _.throttle(function (e) {
    $(document).trigger('stickyHeader');
  }, 20)
);

// trigger the function on page load
$(document).trigger('stickyHeader');

$(document).on('stickyHeader', function () {
  var footerTop = footer.offset().top - $(document).scrollTop() + 120;
  $('header').toggleClass('js-sticky', $(window).scrollTop() > flag);
  $('header').toggleClass('js-sticky-bottom', footerTop < 200);
});
